module.exports = __webpack_public_path__ + "img/navbar_hoverMenu_3_1.962def63.png";